module.exports = __webpack_public_path__ + "static/img/light.83403fa7.svg";